import { useEffect, useState } from "react";
import { Toaster } from "sonner";
import { useLenis, scrollToId } from "@/lib/smoothScroll";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Intro } from "@/components/site/Intro";
import { Marquee } from "@/components/site/Marquee";
import { Lookbook } from "@/components/site/Lookbook";
import { HowToWear } from "@/components/site/HowToWear";
import { Pillars } from "@/components/site/Pillars";
import { OrderForm } from "@/components/site/OrderForm";
import { Footer } from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  useEffect(() => {
    const id = window.location.hash.slice(1);
    if (!id) return undefined;
    const t = setTimeout(() => scrollToId(id), 400);
    return () => clearTimeout(t);
  }, []);
  const [kaba, setKaba] = useState("burgundy-beaded");
  const orderKaba = (id) => {
    setKaba(id);
    scrollToId("order");
  };

  return (
    <div className="bg-ink font-body text-cream antialiased" data-testid="hilmays-modern-site">
      <div className="grain-overlay" aria-hidden="true" />
      <Nav />
      <main>
        <Hero />
        <Intro />
        <Marquee />
        <Lookbook onOrder={orderKaba} />
        <HowToWear />
        <Pillars />
        <OrderForm kaba={kaba} setKaba={setKaba} />
      </main>
      <Footer />
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#131217", border: "1px solid rgba(212,175,55,0.35)", color: "#F5F2EB" } }} />
    </div>
  );
}
